import Voter from "./Voter";

export default Voter;